import actionCreatorFactory from 'typescript-fsa'
import { AudioPreview, AudioSectionContainer, PlayerStatus, PreviewData } from './types'

const actionCreator = actionCreatorFactory('AudioPlayer')

export interface LoadAudioParams {
	container: AudioSectionContainer
	audio: AudioPreview
	data: PreviewData
}
export const loadAudioPreview = actionCreator<LoadAudioParams>('LOAD_AUDIO_PREVIEW')
export interface LoadAudioErrorParams {
	audioId: number
	error: unknown
	container: AudioSectionContainer
	fileId: number
}
export const loadAudioError = actionCreator<LoadAudioErrorParams>('LOAD_AUDIO_ERROR')
export interface SetCurrentTimeParams {
	audioId: number
	time: number // in seconds
	container: AudioSectionContainer
	fileId: number
}
export const setCurrentTime = actionCreator<SetCurrentTimeParams>('SET_CURRENT_TIME')

export interface SetAudioDurationParams {
	audioId: number
	duration: number
	container: AudioSectionContainer
	fileId: number
}
export const audioLoaded = actionCreator<SetAudioDurationParams>('SET_AUDIO_DURATION')

export interface SetPlayerStatusParams {
	audioId: number
	status: PlayerStatus
	container: AudioSectionContainer
	fileId: number
}
export const setPlayerStatus = actionCreator<SetPlayerStatusParams>('SET_PLAYER_STATUS')

export interface SetAudioEndedParams {
	audioId: number
	container: AudioSectionContainer
	fileId: number
}
export const setAudioEnded = actionCreator<SetAudioEndedParams>('SET_AUDIO_ENDED')
